import connect from "../scripts/database.js";

export var Activity = {
  userActivity(currentUser, type, params) {
    connect.db
      .collection(`users/${currentUser.uid}/activity`)
      .add({
        actor: currentUser.uid || "anonymous",
        actorName: currentUser.name || "Anonymous",
        actorType: "customer",
        type: type,
        timestamp: Date.now(),
        params: params
      })
      .then(result => {
        //(result.id);
      })
      .catch(error => {
        console.warn(error);
      });
  }
};

export default Activity;
